import React from "react";
import { Link } from "react-router-dom";
import "../../styles/recentLeads.css";

const stageClassMap = {
  "New": "stage-new",
  "Contacted": "stage-contacted",
  "Qualified": "stage-qualified",
  "Quotation Sent": "stage-quotation",
  "Negotiating": "stage-negotiating",
  "Won": "stage-won",
  "Lost": "stage-lost",
};

export default function RecentLeads({ leads = [], loading = false }) {
  
  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric'
    });
  };

  if (loading) {
    return (
      <div className="recent-leads-card">
        <div className="recent-leads-header">
          <h3>Recent Leads</h3>
        </div>
        <div className="loading-text">Loading leads...</div>
      </div>
    );
  }

  return (
    <div className="recent-leads-card">
      {/* Header */}
      <div className="recent-leads-header">
        <h3>Recent Leads</h3>
        <Link to="/leads" className="view-all">
          View All →
        </Link>
      </div>

      {/* Content */}
      {leads.length === 0 ? (
        <div className="recent-leads-empty">
          No leads found. Start capturing leads to see them here!
        </div>
      ) : (
        <div className="recent-leads-list">
          {leads.map((lead) => (
            <Link
              key={lead._id} 
              to={`/leads/${lead._id}`} 
              className="recent-lead-item"
            >
              <div className="lead-top">
                <div className="lead-info">
                  <h4>{lead.fullName || "Unnamed Lead"}</h4> {/* Changed from full_name to fullName */}
                  <p className="lead-email">{lead.email || "No email"}</p>
                </div>

                <div className="lead-right">
                  <span
                    className={`lead-stage ${stageClassMap[lead.status] || "stage-default"}`} 
                  >
                    {lead.status || "New"} {/* Changed from stage to status */}
                  </span>
                  {lead.createdDate && (
                    <span className="lead-date">
                      {formatDate(lead.createdDate)}
                    </span>
                  )}
                </div>
              </div>

              <div className="lead-meta">
                {lead.destinationInterest && ( /* Changed from destination_interest to destinationInterest */
                  <span className="meta-item">
                    <span className="meta-icon">📍</span>
                    {lead.destinationInterest}
                  </span>
                )}
                {lead.travelInterest && ( /* Added travel interest */
                  <span className="meta-item">
                    <span className="meta-icon">🏝️</span>
                    {lead.travelInterest}
                  </span>
                )}
                {lead.numberOfTravelers && ( /* Changed from number_of_travelers to numberOfTravelers */
                  <span className="meta-item">
                    <span className="meta-icon">👥</span>
                    {lead.numberOfTravelers} travelers
                  </span>
                )}
                {lead.budgetRange && ( /* Changed from budget_range to budgetRange */
                  <span className="meta-item">
                    <span className="meta-icon">💰</span>
                    {lead.budgetRange}
                  </span>
                )}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}